import {getActionType, TYPES} from '../util/redux';
import { WelcomeType, PAGESIZE } from '../action/welcome';

const initState = {
    page: 1,
    total: 1,
    request: true,
    data: {},
    hasMore: true,
    msg: '',
    data0: [],
    page0: 0,
    hasMore0: false,
    data1: [],
    page1: 0,
    hasMore1: false,
    // task详情
    taskDetail: null,
    subRequesting: false,
    listRequesting: false,
    // 数据中心数据 yesterdayIncrFans,yesterdayIncrPlayCount,totalPubCount
    yesterdayIncrFans: null,
    yesterdayIncrPlayCount: null,
    totalPubCount: 0,
    yesterdayInterface: null,
    manPlanInfo: null,
    normalMainPlanInfo: null,
    // 现金收益
    cashAmount: 0,
    yesterAmount: 0,
    yesterDate: '',
    coefficient: 0,
}

const type1 = getActionType(WelcomeType, 'request');
const getMsg = getActionType(WelcomeType, 'getmsg');
const type2 = getActionType(WelcomeType, 'msgfail');
const savePage = getActionType(WelcomeType, 'savepage');
const makeRead = getActionType(WelcomeType, 'makeread');
const makeAllRead = getActionType(WelcomeType, 'makeallread');
const getGenetalInfo = getActionType(WelcomeType, 'getgeneralinfodata');
const getMoneyearns = getActionType(WelcomeType, 'getmoneyearns');
const SUBINIT = getActionType(WelcomeType, 'subInit');
const SUBDONE = getActionType(WelcomeType, 'subDone');
const LISTINIT = getActionType(WelcomeType, 'listInit');
const LISTDONE = getActionType(WelcomeType, 'listDone');
const GETCOLLECTIONALLTASKLISTSUCCESS = getActionType(WelcomeType, 'getCollectionAllTaskListSuccess');
const GETCOLLECTIONTASKPARTICIPATELISTSUCCESS = getActionType(WelcomeType, 'getCollectionTaskParticipateListSuccess');
const GETCOLLECTIONTASKDETAILSUCCESS = getActionType(WelcomeType, 'getCollectionTaskDetailSuccess');
const RESETTASKDETAIL = getActionType(WelcomeType, 'resettaskdetail');
const RESETTASKDATA = getActionType(WelcomeType, 'resetTasksData');
const FETCHMANPLANINFOSUCCESS = getActionType(WelcomeType, 'fetchManPlanInfoSuccess');
const FETCHNORMALMANPLANINFOSUCCESS = getActionType(WelcomeType, 'fetchNormalManPlanInfoSuccess');

export default function welcomeReducer(state=initState,action) {
    let { type, payload } = action;
    let data;
    switch(type) {
        case type1:
            // 发送请求
            return {
                ...state,
                request: true
            }
        case getMsg:
            // 获取消息列表
            let page = payload.page;
            let total = payload.total;
            let list = payload.data;
            let odata = state.data;
            odata[page] = list;
            let hasMore = payload.hasMore;
            return {
                ...state,
                request: false,
                msg: '',
                data: odata,
                page: page,
                total: total,
                hasMore: hasMore
            }
        case makeRead:
            // 发送已读消息
            let readpage = payload.page;
            let readindex = payload.index;
            let readdata = state.data;
            readdata[readpage][readindex].read = true;
            return {
                ...state,
                request: false,
                msg: '',
                data: readdata
            }
        case makeAllRead:
            state.data[payload.page] = state.data[payload.page].map(item => Object.assign({}, item, {
                read: true
            }));
            return {
                ...state,
                data: state.data
            }
        case getGenetalInfo:
            // 获取数据中心数据
            let {  yesterdayIncrFans,yesterdayIncrPlayCount,totalPubCount } = payload;
            return {
                ...state,
                yesterdayIncrFans: yesterdayIncrFans,
                yesterdayIncrPlayCount: yesterdayIncrPlayCount,
                totalPubCount: totalPubCount,
                yesterdayInterface: payload
            }
        case getMoneyearns:
            // 获取现金收益数据
            let yesterDate,yesterAmount,cashAmount;
            let earnlist = payload.videoEarningsVoList;
            let coefficient = payload.coefficient;
            for(var i=0;i<earnlist.length;i++){
                if(earnlist[i].type === 2) {
                  yesterDate = earnlist[i].earningsDate.slice(5);
                  yesterAmount = '￥' + earnlist[i].earningsAmount;
                }else if(earnlist[i].type === 3) {
                  yesterDate = '';
                  yesterAmount = earnlist[i].earningsAmount;
                }else if(earnlist[i].type === 4) {
                  cashAmount ='￥' + earnlist[i].earningsAmount;
                }
            }
            return {
                ...state,
                yesterDate: yesterDate,
                yesterAmount: yesterAmount,
                cashAmount: cashAmount,
                coefficient: coefficient,
            }
        case type2:
            // 请求失败
            let rmsg = payload.msg;
            return {
                ...state,
                request: false,
                msg: rmsg
            }
        case savePage:
            return {
                ...state,
                page: payload.page
            }
        case GETCOLLECTIONALLTASKLISTSUCCESS:
            // 过滤重复taskId的征稿
            let data0 = state.data0;
            payload.data.forEach(item => {
                if(!data0.some(v => v.taskId === item.taskId)) {
                    data0.push(item);
                }
            })

            return {
                ...state,
                data0,
                page0: payload.page,
                hasMore0: payload.hasMore
            }
        case GETCOLLECTIONTASKPARTICIPATELISTSUCCESS:
            return {
                ...state,
                data1: state.data1.concat(payload.data),
                page1: payload.page,
                hasMore1: payload.hasMore
            }
        case SUBINIT:
            return {
                ...state,
                subRequesting: true
            }
        case SUBDONE:
            return {
                ...state,
                subRequesting: false
            }
        case LISTINIT:
            return {
                ...state,
                listRequesting: true
            }
        case LISTDONE:
            return {
                ...state,
                listRequesting: false
            }
            // 获取任务详情成功
        case GETCOLLECTIONTASKDETAILSUCCESS:
            return {
                ...state,
                taskDetail: payload.data
            }
            // 重置任务详情页
        case RESETTASKDETAIL:
            return {
                ...state,
                taskDetail: null
            }
            // 重置任务列表
        case RESETTASKDATA:
            return {
                ...state,
                data0: [],
                page0: 0,
                hasMore0: false,
                data1: [],
                page1: 0,
                hasMore1: false
            }
            // 获取达人计划详情
        case FETCHMANPLANINFOSUCCESS:
            return {
                ...state,
                manPlanInfo: payload
            }
        case FETCHNORMALMANPLANINFOSUCCESS:
            return {
                ...state,
                normalMainPlanInfo: payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./client/reducers/welcome.js